import { Id } from "../helpers/Id";
import { Populatable } from "../helpers/Populatable";
import { WithModelIds } from "../helpers/WithModelIds";
import { PopulatedAssetHolding } from "./AssetHoldingBase";
import { DataSourceBase } from "./DataSourceBase";
import { ModelBase } from "./ModelBase";
import { UserBase } from "./UserBase";

export interface WalletBase<TId> extends ModelBase<TId> {
  owner: Populatable<TId, UserBase<TId>>;
  dataSource: Id<TId> | DataSourceBase<TId>;
  apiKey?: string;
  secretKey?: string;
  passphrase?: string;
  addresses?: string[];
  customName?: string;
  fromDate?: Date;

  authorised?: boolean;

  allowSync: boolean;

  transactionCount?: number;

  // last sync date
  lastSynced?: Date;

  // last file upload date
  lastUploaded?: Date;
  importMethod: WalletImportMethod;

  /**
   * This prop stores something to reference the most recent api imported ledger (e.g. BTC Markets ledger id, etc)
   * Typed string as we don't know the possible formats of ledger id/reference from the other data sources
   */
  lastImportedLedgerReference?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface WalletWithHoldings<TId> extends WithModelIds<WalletBase<TId>> {
  holdings?: PopulatedAssetHolding<TId>[];
}

export interface PopulatedWallet<TId> extends WithModelIds<WalletBase<TId>> {
  dataSource: WithModelIds<DataSourceBase<TId>>;
  holdings?: PopulatedAssetHolding<TId>[];
}

export enum WalletImportMethod {
  API = "API",
  CSV = "CSV",
}
